$(document).ready(function(){
  $(".timeline_carousel").each(function(){
    $(this).owlCarousel({
      // Opzioni del carosello
      loop: true,
      margin: 10,
      nav: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        1000: {
          items: 4
        }
      }
    });
  });
  $(".valori_carousel").each(function(){
    $(this).owlCarousel({
      // Opzioni del carosello
      loop: true,
      margin: 50,
      stagePadding: 90,
      loop:false,
      nav: false,
      responsive: {
        0: {
          items: 1,
          margin: 30,
          stagePadding: 70,
        },
        600: {
          items: 2,
          margin: 30,
          stagePadding: 70,
        },
        1000: {
          items: 4
        }
      }
    });
  });
});
